<ng-container>
  <div class="ppt-body-content">
    <div class="record-address-section">
      <ppt-record-header
        [reportData]="reportData()"
        [reportRecordData]="reportRecordData"
        [currentView]="currentView()"
        [headerFields]="headerFields"
        [templateProjectionMap]="templateProjectionMap()"
      ></ppt-record-header>
    </div>
    <div class="record-img-attribute-section">
      <div class="record-img-content">
        @if (!isSecondaryImageRequired) {
          <ppt-record-image
            [reportId]="reportData()?.reportId"
            [reportRecordData]="reportRecordData"
            [allFields]="allFields"
            [currentView]="currentView()"
          ></ppt-record-image>
        }
        @if (isSecondaryImageRequired) {
          <rep-presentation-dynamic-view-image
            [reportId]="reportData()?.reportId"
            [reportRecordData]="reportRecordData"
            [imageGroups]="imageGroups()"
            [currentView]="currentView()"
          ></rep-presentation-dynamic-view-image>
        }
      </div>
      <div class="body-content">
        @if (currentView()?.templateId != null) {
          <div class="record-attribute-content">
            <ul class="record-list">
              @if (confidentialityTmpl() && !isSecondaryImageRequired) {
                <li>
                  <ng-container
                    *ngTemplateOutlet="confidentialityTmpl(); context: { reportItem: reportRecordData, displayLabel: true }"
                  ></ng-container>
                </li>
              }
              @for (field of allDataFields; track field) {
                <li (click)="emitEditableFields($event, field.id)">
                  <label
                    class="record-attribute-key"
                    [ngClass]="{ clickable: editableFieldsService.editableTemplateAttributes[field.id] }"
                    >{{ reportRecordData | reportLabelFormatter: { templateId: currentView().templateId, field: field } }}
                  </label>
                  <span
                    class="record-attribute-value"
                    [ngClass]="{ clickable: editableFieldsService.editableTemplateAttributes[field.id] }"
                    >{{
                    reportRecordData
                    | reportFieldFormatter
                    : {
                    templateId: currentView().templateId,
                    field: field,
                    joinString: true,
                    onlyUrl: false,
                    symbols: customConfigs()?.symbols,
                  }
                  | async
                  }}</span
                  >
                </li>
              }
            </ul>
          </div>
        } @else {
          <!-- TODO: add localization-->
          <div>No data available</div>
        }
        <ng-container>
          @if (isSecondaryImageRequired) {
            <div
              class="bottom-section"
              [ngClass]="tableFields?.fields?.length ? 'inline-bottom-section' : ''"
              >
              @if (tableFields) {
                <div class="table-section">
                  @if (tableFields.tableConfigs?.tableTitle) {
                    <h3 class="table-title">
                      {{ reportRecordData?.data.length }}
                      {{
                      (reportRecordData?.data.length > 0 ? 'template.availabilities' : 'template.availability') | translate
                      }}
                    </h3>
                  }
                  <table class="template-table">
                    <thead>
                      <tr>
                        @if (tableFields.tableConfigs?.actionCol) {
                          <th></th>
                        }
                        @for (col of tableFields.fields; track col) {
                          @if (reportRecordData | isFieldVisible: { templateId: currentView().templateId, field: col }) {
                            <th
                              [ngClass]="col.class"
                              >
                              <span>{{ col.label }}</span>
                            </th>
                          }
                        }
                        @if (confidentialityTmpl()) {
                          <th>
                            {{ 'template.reportConfidentiality' | translate }}
                          </th>
                        }
                      </tr>
                    </thead>
                    <tbody cdkDropList (cdkDropListDropped)="onReorder($event, reportRecordData)">
                      @for (data of tableData; track data; let i = $index) {
                        <tr cdkDrag cdkDragLockAxis="y">
                          @if (tableFields.tableConfigs?.actionCol) {
                            <td class="actions">
                              <a class="action-element"
                                ><mat-icon
                                class="handle print-hidden"
                                svgIcon="alt-handle-icon"
                                color="y-icon"
                                cdkDragHandle
                                ></mat-icon
                              ></a>
                              <a class="action-element" (click)="removeRecord.emit(data)"
                                ><mat-icon class="green-close" color="y-icon" svgIcon="close-icon-grey"></mat-icon
                              ></a>
                              <!-- TODO: instead of goToRecordDetails() method need to use miq-goes-to-record once feild from BE is available -->
                              <a (click)="goToRecordDetails(data)" class="action-element">
                                <mat-icon class="print-hidden" color="y-icon" svgIcon="open_in_browser"> </mat-icon>
                              </a>
                              <b>{{ i + 1 }}.</b>
                            </td>
                          }
                          @for (col of tableFields.fields; track col; let i = $index) {
                            @if (reportRecordData | isFieldVisible: { templateId: currentView().templateId, field: col }) {
                              <td>
                                <span>{{
                                  { recordId: null, position: null, edpRecordId: null, confidentiality: null, data: [data] }
                                  | reportFieldFormatter
                                  : {
                                  templateId: currentView().templateId,
                                  field: col,
                                  joinString: true,
                                  onlyUrl: false,
                                }
                                | async
                              }}</span>
                            </td>
                          }
                        }
                        @if (confidentialityTmpl()) {
                          <td>
                            <div class="confidentialityInTable">
                              <ng-container
                                style="position: absolute"
                          *ngTemplateOutlet="
                            confidentialityTmpl();
                            context: {
                              record: data,
                              reportItem: reportRecordData,
                              displayLabel: true,
                              isDataOnly: true,
                            }
                          "
                            ></ng-container>
                          </div>
                        </td>
                      }
                    </tr>
                  }
                  @if (tableData?.length === 0) {
                    <tr>
                      <td [attr.colspan]="tableFields.tableConfigs.colspan">{{ 'template.noData' | translate }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </div>
      }
    </ng-container>
    @if (floorPlanTemplateIds) {
      <floor-plan [reportId]="reportData()?.reportId" [reportRecordData]="reportRecordData"></floor-plan>
    }
  </div>
</div>
</div>
</ng-container>
